const darktheme = require('../../../../../components/darktheme/darktheme')

// esta funcion es llamada cuando se hace click en el button y dependiendo si el tema oscuro esta activo o no
export function checkDarkTheme(detail) {
   if (darktheme.checkIfExistsDarkTheme()) {
      darktheme.removeDarkTheme()
   } else {
      darktheme.setDarkTheme()
   }
} 
